import type { LucideIcon } from 'lucide-react'
import {
  Table2,
  Users,
  Fingerprint,
  KeyRound,
  Building2,
  GitBranch,
  Building,
  UserCog,
  Shield,
  Mail,
  Handshake,
  BarChart3,
  User,
  GraduationCap,
  Briefcase,
  ClipboardList,
  FileText,
  MessageSquare,
  ClipboardCheck,
  Mic,
  CreditCard,
  Layers,
  Coins,
  Package,
  FileSignature,
  Plug,
  AlertTriangle,
  Rocket,
  ArrowLeftRight,
  Share2,
  MessageCircle,
  Newspaper,
  Ban,
  Send,
  LayoutTemplate,
  Globe,
  Phone,
  ScrollText,
  Flag,
  ShieldCheck,
} from 'lucide-react'

export const RESOURCE_ICONS: Record<string, LucideIcon> = {
  users: Users,
  identity: Fingerprint,
  user_tokens: KeyRound,
  companies: Building2,
  branches: GitBranch,
  departments: Building,
  company_users: UserCog,
  company_roles: Shield,
  company_email_configuration: Mail,
  agencies: Handshake,
  services_count: BarChart3,
  local_candidates: User,
  job_seekers: Briefcase,
  candidate_educations: GraduationCap,
  candidate_experiences: Briefcase,
  candidate_courses: GraduationCap,
  candidate_projects: ClipboardList,
  candidate_languages: MessageSquare,
  candidate_documents: FileText,
  company_positions: Briefcase,
  position_stages: Layers,
  position_questions: MessageSquare,
  position_assigned_users: Users,
  evaluation_weights: BarChart3,
  requisitions: ClipboardList,
  approval_requests: ClipboardCheck,
  applications: FileText,
  interview_versions: Mic,
  interview_questions: MessageSquare,
  evaluation_forms: ClipboardCheck,
  voice_over_rate_limits: Mic,
  voice_over_audit_logs: ScrollText,
  subscriptions: CreditCard,
  plans: Layers,
  tokens: Coins,
  add_on_packages: Package,
  offer_letters: FileSignature,
  feature_flags: Flag,
  account_feature_overrides: ShieldCheck,
  partner_api_keys: Plug,
  partner_assessments: ClipboardCheck,
  greenhouse_request_errors: AlertTriangle,
  onboarding_services: Rocket,
  onboarding_service_transfer_history: ArrowLeftRight,
  candidate_data_transferred_fields: Share2,
  organization_assigned_users: Users,
  whatsapp_messages: MessageCircle,
  newsletter_subscriptions: Newspaper,
  blacklisted_emails: Ban,
  email_history: Send,
  company_templates: LayoutTemplate,
  product_demo_requests: Phone,
  public_api_contact_requests: Globe,
  public_api_signing_challenges: KeyRound,
  public_api_request_logs: ScrollText,
}

export function getResourceIcon(name: string): LucideIcon {
  return RESOURCE_ICONS[name] ?? Table2
}
